import { post } from "@/services/axiosUitils";
import { getProjectPhoneCode } from "./shared/config";

export interface RequestOtpResponse {
  code_reference?: string;
  message?: string;
  data?: any;
  [key: string]: any;
}

export interface VerifyOtpResponse {
  access?: string;
  refresh?: string;
  token?: string;
  user?: any;
  code_reference?: string;
  message?: string;
  data?: any;
  [key: string]: any;
}

export interface SignupDetailsPayload {
  first_name: string;
  last_name: string;
  email: string;
  date_of_birth: string;
  gender: string;
  phone_number: string;
  username: string;
  phone_code?: string;
  [key: string]: any;
}

export const authService = {
  /**
   * Step 1 Signup API: Send phone + phone_code + all user details to get code_reference
   */
  async requestSignupOtp(
    payload: SignupDetailsPayload
  ): Promise<RequestOtpResponse> {
    const res = await post<any>("/auth/", {
      ...payload,
      phone_code: payload.phone_code ?? getProjectPhoneCode(),
    });
    return res;
  },

  /**
   * Step 2 Verify Signup OTP API: Send OTP and code_reference
   */
  async verifySignupOtp(
    otp: string,
    codeReference: string
  ): Promise<VerifyOtpResponse> {
    const res = await post<any>("/auth/", {
      otp,
      code_reference: codeReference,
    });
    return res;
  },

  /**
   * Step 1 Login API: Send phone number and phone_code to get code_reference
   */
  async requestLoginOtp(phoneNumber: string): Promise<RequestOtpResponse> {
    const phoneCode = getProjectPhoneCode();
    const res = await post<any>("/auth/login/", {
      phone_number: phoneNumber,
      phone_code: phoneCode,
    });
    return res;
  },

  /**
   * Step 2 Verify Login OTP API: Send OTP and code_reference
   */
  async verifyLoginOtp(
    otp: string,
    codeReference: string
  ): Promise<VerifyOtpResponse> {
    const res = await post<any>("/auth/login/", {
      otp,
      code_reference: codeReference,
    });
    return res;
  },
};
